"use client";
import { useState } from "react";
import { HStack, PinInput, PinInputField } from "@chakra-ui/react";

interface OTPInputProps {
  length?: number;
  onComplete: (otp: string) => void;
}

export default function OTPInput({ length = 6, onComplete }: OTPInputProps) {
  const [otp, setOtp] = useState("");

  const handleChange = (value: string) => {
    setOtp(value);
    if (value.length === length) {
      onComplete(value);
    }
  };

  return (
    <HStack justify="center" spacing={4}>
      <PinInput
        value={otp}
        onChange={handleChange}
        size="lg"
        placeholder=""
        type="number"
      >
        {Array.from({ length }).map((_, index) => (
          <PinInputField
            key={index}
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            _focus={{
              borderColor: "primary.500",
              boxShadow: "0 0 0 1px var(--chakra-colors-primary-500)",
            }}
            textFillColor={"gray.600"}
            sx={{ caretColor: "black" }}
          />
        ))}
      </PinInput>
    </HStack>
  );
}
